import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as IgLive } from '../../images/ig-live.svg';

export const IgLiveIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={IgLive} />
);

export default IgLiveIcon;
